var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13842_114733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.875 12C24.875 5.376 19.499 0 12.875 0C6.251 0 0.875 5.376 0.875 12C0.875 17.808 5.003 22.644 10.475 23.76V15.6H8.075V12H10.475V9C10.475 6.684 12.359 4.8 14.675 4.8H17.675V8.4H15.275C14.615 8.4 14.075 8.94 14.075 9.6V12H17.675V15.6H14.075V23.94C20.135 23.34 24.875 18.228 24.875 12Z",
    fill: "#1877F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13842_114733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.875)"
  })))));
};
export default SvgFacebook;